import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { AuthGuard } from './guards/auth.guard';


const routes: Routes = [
  {
    path: '',
    redirectTo: 'login',
    pathMatch: 'full'
  },
  {
    path: 'home',
    loadChildren: () => import('./home/home.module').then( m => m.HomePageModule),
    canActivate: [AuthGuard],
    data: { roles: ['user', 'Admin', 'Reseller', 'Superadmin'] }
  },
  {
    path: 'dashboard',
    loadChildren: () => import('./dashboard-module/dashboard-module.module').then( m => m.DashboardModuleModule),
    canActivate: [AuthGuard],
    data: { roles: ['user', 'Admin', 'Reseller', 'Superadmin'] }
  },
  {
    path: '',
    loadChildren: () => import('./login-module/login-module.module').then( m => m.LoginModuleModule)
  },
  {
    path: 'otp',
    loadChildren: () => import('./otp-module/otp-module.module').then( m => m.OtpModuleModule)
  },
  {
    path: 'user',
    loadChildren: () => import('./user-module/user-module.module').then( m => m.UserModuleModule),
    canActivate: [AuthGuard],
    data: { roles: ['Admin','Reseller','Superadmin'] }
  },
  {
    path: 'system-traffic',
    loadChildren: () => import('./system-traffic-module/system-traffic-module.module').then( m => m.SystemTrafficModuleModule),
    canActivate: [AuthGuard],
    data: { roles: ['Reseller','Superadmin'] }
  },
  {
    path: 'send-message',
    loadChildren: () => import('./rcs-module/rcs-module.module').then( m => m.RcsModuleModule),
    canActivate: [AuthGuard]
  },

  

  {
    path: 'rcs-reports',
    loadChildren: () => import('./rcs-reports/rcs-reports.module').then( m => m.RcsReportsPageModule)
  },
  {
    path: 'rcs-today-reports',
    loadChildren: () => import('./rcs-today-reports/rcs-today-reports.module').then( m => m.RcsTodayReportsPageModule)
  },
  {
    path: 'sms',
    loadChildren: () => import('./sms-module/sms-module.module').then( m => m.SmsModuleModule)
  },
  {
    path: 'rcs-summary',
    loadChildren: () => import('./rcs-summary/rcs-summary.module').then( m => m.RcsSummaryPageModule)
  },
  {
    path: 'rcs-archieve-reports',
    loadChildren: () => import('./rcs-archieve-reports/rcs-archieve-reports.module').then( m => m.RcsArchieveReportsPageModule)
  },
  {
    path: 'whatsapp',
    loadChildren: () => import('./whatsapp-module/whatsapp-module.module').then( m => m.WhatsappModuleModule),
    canActivate: [AuthGuard],
    data: { roles: ['user', 'Admin','Reseller', 'Superadmin'] }
  },
  {
    path: 'voice',
    loadChildren: () => import('./voice-module/voice-module.module').then( m => m.VoiceModuleModule)
  },
  {
    path: 'group',
    loadChildren: () => import('./group-module/group-module.module').then( m => m.GroupModuleModule)
  },
  {
    path: 'privacy-policy',
    loadChildren: () => import('./privacy-policy-module/privacy-policy-module.module').then( m => m.PrivacyPolicyModuleModule),
    canActivate: [AuthGuard],
    data: { roles: ['user', 'Admin','Reseller', 'Superadmin'] }
  },
  {
    path: 'wallet',
    loadChildren: () => import('./wallet-module/wallet-module.module').then( m => m.WalletModuleModule)
  },
  {
    path: 'missed-call',
    loadChildren: () => import('./missed-call-module/missed-call-module.module').then( m => m.MissedCallModuleModule)
  },
  {
    path: 'rcs-messaging',
    loadChildren: () => import('./rcs-messaging-module/rcs-messaging-module.module').then( m => m.RcsMessagingModuleModule),
    canActivate: [AuthGuard],
    data: { roles: ['user', 'Admin','Reseller', 'Superadmin'] }
  },
  {
    path: 'business',
    loadChildren: () => import('./business-module/business-module.module').then( m => m.BusinessModuleModule),
    canActivate: [AuthGuard],
    data: { roles: ['user', 'Admin','Reseller', 'Superadmin'] }
  },
  {
    path: 'bsp-whatsapp',
    loadChildren: () => import('./bsp-whatsapp/bsp-whatsapp.module').then( m => m.BspWhatsappModule),
    canActivate: [AuthGuard],
    data: { roles: ['user', 'Admin','Reseller', 'Superadmin'] }
  },
  {
    path: 'password',
    loadChildren: () => import('./password-module/password-module.module').then( m => m.PasswordModuleModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'credit',
    loadChildren: () => import('./credit-history-module/credit-history-module.module').then( m => m.CreditHistoryModuleModule),
    canActivate: [AuthGuard],
    data: { roles: ['user', 'Admin','Reseller', 'Superadmin'] }
  },
  {
    path: 'flowchart',
    loadChildren: () => import('./flowchart-module/flowchart-module.module').then( m => m.FlowchartModuleModule),
    canActivate: [AuthGuard],
    data: { roles: ['user', 'Admin','Reseller', 'Superadmin'] }
  },
  {
    path: 'team',
    loadChildren: () => import('./team-module/team-module.module').then( m => m.TeamModuleModule),
    canActivate: [AuthGuard],
    data: { roles: ['user', 'Admin','Reseller', 'Superadmin'] }
  },
  {
    path: 'brand',
    loadChildren: () => import('./brand-module/brand-module.module').then( m => m.BrandModuleModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'jrcs',
    loadChildren: () => import('./jio-rcs-module/jio-rcs-module.module').then( m => m.JioRcsModuleModule),
    canActivate: [AuthGuard],
    data: { roles: ['user', 'Admin','Reseller', 'Superadmin'] }
  },
  {
    path: 'api-docs',
    loadChildren: () => import('./api-docs-module/api-docs-module.module').then( m => m.ApiDocsModuleModule),
    canActivate: [AuthGuard],
    data: { roles: ['user', 'Admin','Reseller', 'Superadmin'] }
  },
  {
    path: 'jwhatsapp',
    loadChildren: () => import('./jwhatsapp/jwhatsapp.module').then( m => m.JwhatsappModule),
    canActivate: [AuthGuard],
    data: { roles: ['user', 'Admin','Reseller', 'Superadmin'] }
  },
  {
    path: 'administration',
    loadChildren: () => import('./administration/administration.module').then( m => m.AdministrationModule),
    canActivate: [AuthGuard],
    data: { roles: ['Admin','Reseller', 'Superadmin'] }
  }
];

@NgModule({
  imports: [
    //RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })
    RouterModule.forRoot(routes, { useHash: true,onSameUrlNavigation: 'reload' }),
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
